import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';;
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import * as _ from 'lodash';

import { Company, Vacancy, VacancyCandidate } from '../../../core/models';
import { StorageService, UserService } from '../../../core/services';
import { CleanObjectService } from '../../../core/services';
import { VacanciesService } from '../../vacancies.service';
import { VacancyCandidatesService } from '../../vacancy-candidates.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-nominate-candidate-modal',
  templateUrl: './nominate-candidate-modal.component.html',
  styleUrls: ['./nominate-candidate-modal.component.scss']
})
export class NominateCandidateModalComponent implements OnInit, OnDestroy {
  public searchVacancyName$ = new Subject<string>();
  @Input() candidates: VacancyCandidate[];
  @Input() vacancy: Vacancy;
  @Input() indicatedFromCandidatesSearch: boolean = false;
  availableVacancies$: Subscription;
  availableVacancies: Vacancy[] = [];
  selectedVacancies = [];
  STATE: 'IDLE' | 'RUNNING' | 'FINALIZED' = 'IDLE';
  private filter: any = {
    filters: {
      status: "published",
      userIds: [],
      companyId: '',
      vacancyId: '',
      office: '',
    },
    pagination: {
      limit: 15,
      skip: 0,
    }
  };
  selectSettings = {
    text: 'Selecione as vagas',
    enableCheckAll: false,
    selectAllText: 'Selecionar todas as vagas',
    unSelectAllText: 'Deselecionar as vagas',
    primaryKey: "_id",
    labelKey: "office",
    searchBy: ['office'],
    noDataLabel: "Buscando vagas",
    enableSearchFilter: true,
  }
  private company: Company;

  constructor(
    private activeModal: NgbActiveModal,
    private userService: UserService,
    private vacanciesService: VacanciesService,
    private vacancyCandidatesService: VacancyCandidatesService,
    private storageService: StorageService,
    private cleanObjectService: CleanObjectService,
    private toastrService: ToastrService
  ) { }

  ngOnInit() {
    this.company = this.storageService.getCompany();
    this.filter.filters.companyId = this.company._id;
    this.filter.filters.vacancyId = this.vacancy._id;

    if (typeof this.vacancy.isEducationCourse === 'boolean') {
      this.filter.filters.isEducationCourse = this.vacancy.isEducationCourse;
    }

    if (this.candidates.length) {
      this.filter.filters.userIds = this.candidates.map(c => c.user._id);
    }

    this.STATE = 'RUNNING';
    this.availableVacancies$ = this.vacanciesService.getVacanciesAvailableToNominate(this.cleanObjectService.getCleanedAttribute(this.filter)).subscribe(res => {
      this.availableVacancies = res.data;
      this.STATE = 'FINALIZED';
    });

    this.searchVacancyName$.pipe(debounceTime(800), distinctUntilChanged()).subscribe(value => {
      this.STATE = 'RUNNING';
      this.filter.filters.office = value;
      this.availableVacancies$ = this.vacanciesService.getVacanciesAvailableToNominate(this.cleanObjectService.getCleanedAttribute(this.filter)).subscribe(res => {
        this.availableVacancies = res.data;
        this.STATE = 'FINALIZED';
      })
    })
  }

  ngOnDestroy(): void {
    this.availableVacancies$.unsubscribe();
    this.searchVacancyName$.unsubscribe();
  }

  public getUserFullName(user: any): string {
    return this.userService.getUserFullName(user);
  }

  public nominateCandidate(): void {
    const params: any = {
      vacancyId: this.vacancy._id,
      companyId: this.company._id,
      userIds: this.candidates.map(c => c.user._id),
      userManagerId: this.storageService.getUser()._id,
      selectedVacancyIds: this.selectedVacancies.map(v => v._id),
      indicatedFromCandidatesSearch: this.indicatedFromCandidatesSearch
    };

    this.vacancyCandidatesService.nominateVacancyCandidateToVacancies(params)
      .subscribe((response: any) => {
        this.toastrService.clear();
        this.toastrService.success(`O candidato foi indicado para vaga${this.selectedVacancies.length === 1 ? '' : 's'}.`, `Candidatos indicado!`);
        this.closeModal();
      }, (err) => { })
  }

  public closeModal(): void {
    if (this.STATE === 'FINALIZED' || this.STATE === 'IDLE') {
      this.activeModal.close();
    } else {
      this.activeModal.close(false);
    }
  }
}
